import type { Database } from "../types/supabase";

export const useClient = useSupabaseClient<Database>;
export type Row<T extends keyof Database["public"]["Tables"]> =
  Database["public"]["Tables"][T]["Row"];
